import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import { PageContent } from "../PageContent";
import { HubIcon } from "../HubIcon";
import { HubButton } from "../inputs";
import { HubCardStack } from "../HubCardStack";
import { EmptyDisplay } from "../../svgs";

const RenderError = () => {
  return (
    <PageContent>
      <HubCardStack
        m="auto"
        justifyContent="center"
        alignItems="center"
        gap="35px"
        maxHeight="min-content"
        padding="100px"
      >
        <Box component="img" src={EmptyDisplay} width="150px" />
        <Stack
          justifyContent="center"
          alignItems="center"
          width="250px"
          sx={{ span: { textAlign: "center", lineHeight: "110%" } }}
          gap="5px"
        >
          <Typography variant="boldCaption" fontSize="20px">
            Oh No!
          </Typography>
          <Typography variant="caption" fontSize="16px">
            There was an error loading the page. Please refresh or navigate back
            home
          </Typography>
        </Stack>
        <Stack direction="row" gap="5px">
          <HubButton
            label="Refresh"
            variant="contained"
            color="grey"
            size="small"
            onClick={() => window.location.reload()}
          />
          <HubButton
            label="Home"
            variant="contained"
            size="small"
            page="/models"
          />
        </Stack>
      </HubCardStack>
    </PageContent>
  );
};

export default RenderError;
